module.exports = __webpack_public_path__ + "media/favicons/favicon-16x16-4f82b1d1.png";